module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "book",
    attrs: {
      "title": "Gil Walsh"
    }
  }, [_c('div', {
    staticClass: "frontmatter"
  }, [_c('div', {
    staticClass: "recto"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "index"
    }
  }), _vm._v("Gil Walsh Interiors")]), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("A Case\n                        For Color")]), _c('h3', {
    staticClass: "author"
  }, [_vm._v("Gil Walsh ")]), _c('h4', [_vm._v("with Margaret Reilly\n                        Muldoon")]), _c('img', {
    attrs: {
      "alt": "Gibbs Smith Logo",
      "src": "images/logo.jpg"
    }
  })]), _c('div', {
    staticClass: "verso"
  }, [_c('p', {
    staticClass: "versotitle"
  }, [_vm._v("Gil Walsh")]), _c('p', {
    staticClass: "versotitle"
  }, [_vm._v("A Case\n                        For Color")]), _c('p', [_vm._v("Digital Edition 1.0")]), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Text © 2016 Gil\n                        Walsh")]), _c('p', [_vm._v("Photos copyright as noted throughout")]), _c('p', [_vm._v("All rights reserved.\n                        No part of this book may be reproduced by any means whatsoever without\n                        written permission from the publisher, except brief portions quoted for\n                        purpose of review.")]), _c('p', {
    staticClass: "nobreak"
  }, [_vm._v("Gibbs Smith")]), _c('p', {
    staticClass: "nobreak"
  }, [_vm._v("P.O. Box 667")]), _c('p', [_vm._v("Layton, Utah 84041")]), _c('p', {
    staticClass: "nobreak"
  }, [_vm._v("Orders:\n                        1.800.835.4993")]), _c('p', [_vm._v("www.gibbs-smith.com")]), _c('p', [_vm._v("ISBN:\n                    978-1-4236-4169-8")])])]), _c('div', {
    staticClass: "frontmatter"
  }, [_c('div', {
    staticClass: "dedication",
    attrs: {
      "title": "Dedication"
    }
  }, [_c('p', [_vm._v("For my mother")]), _c('p', [_vm._v("Mary Gill\n                    Moran")])])]), _c('div', {
    staticClass: "frontmatter"
  }, [_c('div', {
    staticClass: "acknowledgements",
    attrs: {
      "title": "Acknowledgements"
    }
  }, [_c('h3', [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', [_vm._v("Thanks first to my amazing design team for their talent and limitless\n                        enthusiasm; librarian, administration staff, and consultants; they support\n                        me every day, in every way, with unconditional love and encouragement that I\n                        could not live without. ")]), _vm._v(" "), _c('p', [_vm._v("A special thank-you to all my clients over the years, who trusted me with\n                        their most treasured possessions—their homes—and without whom this beautiful\n                        book would not be a reality. ")]), _vm._v(" "), _c('p', [_vm._v("Thanks to Andrea Halley-Wright, who handles my social media; to my thousands\n                        of followers, who continually respond with their approval and likes; and to\n                        the publications that have shown their support by publishing my work. ")]), _vm._v(" "), _c('p', [_vm._v("To everyone who had a hand in the creation and design of this book: all the\n                        photographers who captured the spirit and substance of my design in such\n                        poignant ways; Steven Stolman, who introduced me to Madge Baird; and\n                        everyone at Gibbs Smith who helped to publish A Case For Color; and\n                        especially Margaret Reilly Muldoon, who has promoted my work for years and\n                        whose amazing memory and talent captured my voice. ")]), _vm._v(" "), _c('p', [_vm._v("To my family and everyone at the firm, you inspire and encourage me every\n                        day. I am eternally grateful. ")]), _vm._v(" "), _c('p', [_vm._v("Gil Walsh")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61faee50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = 60
// module chunks = 0